var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vx-card',{staticClass:"card_adjust"},[_c('SMSnb',{staticStyle:{"text-align":"left"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }